import { render, staticRenderFns } from "./PolicyFleetPage.vue?vue&type=template&id=686535e2"
import script from "./PolicyFleetPage.vue?vue&type=script&lang=js"
export * from "./PolicyFleetPage.vue?vue&type=script&lang=js"
import style0 from "./PolicyFleetPage.vue?vue&type=style&index=0&id=686535e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports